module.exports = __webpack_public_path__ + "static/media/Step2.5.be95e763.png";